window.theme = window.theme || {};
window.slate = window.slate || {};

(function() {
  var selectors = {
    cartNoCookiesClass: 'cart--no-cookies',
    cartItem: '.cart-item',
    qtyLink: '.qty-new a, .cart-remove a',
    qtyCurrent: '.qty-current',
    lineTotalPrice: '.cart-item-total-price',
    originalTotalWrap: '.cart-item-original-total',
    originalTotalPrice: '.cart-item-original-total-price',
    yourPriceLabel: '.your-price',
    subtotal: '#CartSubtotal',
    discountTotal: '#cartDiscountTotal',
    headerCartCount: '#CartCount'
  };

  function setLinkLineQty(link, line, quantity) {
    if (!link) return;
    var url;
    try {
      url = new URL(link.href);
    } catch (err) {
      return;
    }
    url.searchParams.set('line', line);
    url.searchParams.set('quantity', quantity);
    link.href = url.toString();
  }

  // Minus/plus/remove hrefs encode line + quantity; re-sync them after each in-place update.
  function updateLineLinks(itemEl, line, quantity) {
    var minusLink = itemEl.querySelector('.qty-new a:first-child');
    var plusLink = itemEl.querySelector('.qty-new a:last-child');
    var removeLink = itemEl.querySelector('.cart-remove a');

    setLinkLineQty(minusLink, line, Math.max(quantity - 1, 0));
    setLinkLineQty(plusLink, line, quantity + 1);
    setLinkLineQty(removeLink, line, 0);
  }

  // The Cart Validation Function can cap a quantity without a usable error
  // (github.com/Shopify/dawn/issues/3529), so compare the settled cart with the request.
  function checkQuantityLimit(cart, line, variantId, requestedQuantity) {
    // Prefer the exact line: the same variant can appear on more than one.
    var lineItem = cart.items[line - 1];
    if (!lineItem || lineItem.variant_id !== variantId) {
      lineItem = cart.items.find(function(item) {
        return item.variant_id === variantId;
      });
    }
    var actualQuantity = lineItem ? lineItem.quantity : 0;

    if (actualQuantity < requestedQuantity && typeof theme.Notify !== 'undefined') {
      theme.Notify.open(
        'error',
        'Only ' + actualQuantity + ' of this item allowed per order.',
        true
      );
    }
  }

  // Shared by both the quantity-change AJAX flow (theme.Cart) and the
  // discount-code AJAX flow (cart-discount.js) -- both mutate the cart and
  // both need every line item's price re-rendered, not just the subtotal.
  // removedLine: the 1-based line just set to quantity 0, if any.
  theme.updateCartLineItems = function(cart, removedLine) {
    var itemEls = Array.prototype.slice.call(document.querySelectorAll(selectors.cartItem));

    // Remove the row that was actually removed, so two lines of the same variant
    // (eg. different proof uploads) keep their own rows.
    if (removedLine && itemEls.length === cart.items.length + 1 && itemEls[removedLine - 1]) {
      itemEls.splice(removedLine - 1, 1)[0].remove();
    }

    // Line keys change on every mutation (Cart Validation Function), so match by position
    // when the rows still line up with the cart's variants in order.
    var alignedByPosition =
      itemEls.length === cart.items.length &&
      itemEls.every(function(itemEl, index) {
        return Number(itemEl.getAttribute('data-variant-id')) === cart.items[index].variant_id;
      });

    var seenPerVariant = {};
    itemEls.forEach(function(itemEl, rowIndex) {
      var variantId = Number(itemEl.getAttribute('data-variant-id'));
      var itemIndex = -1;
      if (alignedByPosition) {
        itemIndex = rowIndex;
      } else {
        // Fallback: the Nth row for a variant maps to its Nth cart line.
        var occurrence = (seenPerVariant[variantId] = (seenPerVariant[variantId] || 0) + 1);
        cart.items.some(function(cartItem, index) {
          if (cartItem.variant_id === variantId && --occurrence === 0) {
            itemIndex = index;
            return true;
          }
          return false;
        });
      }

      // No longer present in the cart -- this was the line that got removed.
      if (itemIndex === -1) {
        itemEl.remove();
        return;
      }

      var item = cart.items[itemIndex];
      var line = itemIndex + 1;
      itemEl.setAttribute('data-line', line);

      var qtyEl = itemEl.querySelector(selectors.qtyCurrent);
      if (qtyEl) qtyEl.textContent = item.quantity;

      var totalPriceEl = itemEl.querySelector(selectors.lineTotalPrice);
      if (totalPriceEl) {
        // shop.money_format includes a <span>, hence innerHTML.
        totalPriceEl.innerHTML = theme.Currency.formatMoney(
          item.final_line_price,
          theme.moneyFormat
        );
      }

      var originalWrapEl = itemEl.querySelector(selectors.originalTotalWrap);
      var originalPriceEl = itemEl.querySelector(selectors.originalTotalPrice);
      var yourPriceLabelEl = itemEl.querySelector(selectors.yourPriceLabel);
      var hasLineDiscount = item.original_line_price !== item.final_line_price;

      if (hasLineDiscount && originalPriceEl) {
        originalPriceEl.innerHTML = theme.Currency.formatMoney(
          item.original_line_price,
          theme.moneyFormat
        );
      }
      if (originalWrapEl) originalWrapEl.style.display = hasLineDiscount ? '' : 'none';
      if (yourPriceLabelEl) yourPriceLabelEl.style.display = hasLineDiscount ? '' : 'none';
      // Matches the server-rendered fallback: when there's no "Website
      // price"/"Your price" pair to show, the price itself renders larger.
      if (totalPriceEl) totalPriceEl.style.fontSize = hasLineDiscount ? '' : '1.7rem';

      updateLineLinks(itemEl, line, item.quantity);
    });
  };

  theme.updateCartTotals = function(cart) {
    // innerHTML throughout for the same reason as above -- theme.moneyFormat
    // wraps amounts in a <span>.
    document.querySelectorAll(selectors.subtotal).forEach(function(el) {
      el.innerHTML = theme.Currency.formatMoney(cart.total_price, theme.moneyFormat);
    });

    var discountEl = document.querySelector(selectors.discountTotal);
    if (discountEl) {
      if (cart.total_discount > 0) {
        discountEl.innerHTML = theme.strings.totalCartDiscount.replace(
          '[savings]',
          theme.Currency.formatMoney(cart.total_discount, theme.moneyFormat)
        );
      } else {
        discountEl.textContent = '';
      }
    }

    // Header cart badge: always rendered, hidden while the cart is empty.
    var headerCountEl = document.querySelector(selectors.headerCartCount);
    if (headerCountEl) {
      headerCountEl.classList.toggle('hide', cart.item_count === 0);

      var priceEl = headerCountEl.querySelector('span');
      if (priceEl) {
        priceEl.innerHTML = theme.Currency.formatMoney(cart.total_price, theme.moneyFormat);
      }

      var fallbackTextEl = headerCountEl.querySelector('.icon__fallback-text');
      if (fallbackTextEl) {
        fallbackTextEl.textContent = theme.strings.cartItemsCount.replace('1', cart.item_count);
      }
    }
  };

  // Financing amounts on the cart page are server-rendered from
  // the page-load total, so re-point them at the new total after AJAX changes.
  theme.updateCartFinancing = function(cart) {
    var paypalEl = document.querySelector('.cart-paypal-message');
    if (paypalEl) {
      paypalEl.setAttribute('amount', (cart.total_price / 100).toFixed(2));
      if (paypalEl.updatePayPalMessage) paypalEl.updatePayPalMessage();
    }

    var klarnaEl = document.querySelector('.cart-financing klarna-placement');
    if (klarnaEl) {
      klarnaEl.setAttribute('data-purchase-amount', cart.total_price);
      try {
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
      } catch (err) {
        console.error('[theme.Cart] KlarnaOnsiteService.push() threw:', err);
      }
    }

    var affirmEl = document.querySelector('.affirm-as-low-as.cart-affirm');
    if (affirmEl) {
      affirmEl.setAttribute('data-amount', cart.total_price);
      if (typeof affirm !== 'undefined' && affirm.ui && typeof affirm.ui.refresh === 'function') {
        try {
          affirm.ui.refresh();
        } catch (err) {
          console.error('[theme.Cart] affirm.ui.refresh() threw:', err);
        }
      }
    }
  };

  // Hide the upgrade/crossgrade and EDU terms rows once no item needs them;
  // same title checks as cart.liquid, run against the updated cart. Any
  // Education product needs the EDU checkbox, whatever its vendor.
  theme.updateCartConditionalCheckboxes = function(cart) {
    var hasUpgrade = cart.items.some(function(item) {
      var variantTitle = item.variant_title || '';
      return item.product_title.indexOf('Upgrade') !== -1 ||
        item.product_title.indexOf('アップグレード') !== -1 ||
        variantTitle.indexOf('Upgrade') !== -1 ||
        variantTitle.indexOf('アップグレード') !== -1 ||
        item.product_title.indexOf('Crossgrade') !== -1 ||
        variantTitle.indexOf('Crossgrade') !== -1;
    });

    var needsEduCheckbox = cart.items.some(function(item) {
      var variantTitle = item.variant_title || '';
      return item.product_title.indexOf('Education') !== -1 || variantTitle.indexOf('Education') !== -1;
    });

    var upgradeCheckbox = document.getElementById('agreeUpgrade');
    var upgradeRow = upgradeCheckbox && upgradeCheckbox.closest('.cart-terms');
    if (upgradeRow) {
      upgradeRow.style.display = hasUpgrade ? '' : 'none';
      // Reset on hide so re-adding an upgrade/crossgrade item later in the
      // same session always requires a fresh confirmation, rather than
      // silently reusing a check left over from a since-removed item.
      if (!hasUpgrade) upgradeCheckbox.checked = false;
    }

    var eduCheckbox = document.getElementById('agreeEdu');
    var eduRow = eduCheckbox && eduCheckbox.closest('.cart-terms');
    if (eduRow) {
      eduRow.style.display = needsEduCheckbox ? '' : 'none';
      if (!needsEduCheckbox) eduCheckbox.checked = false;
    }
  };

  theme.Cart = (function() {
    function Cart(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      var cartJsonEl = document.getElementById('CartJson-' + sectionId);

      if (cartJsonEl) {
        theme.cartObject = JSON.parse(cartJsonEl.innerHTML);
      }

      this.init();
    }

    Cart.prototype = Object.assign({}, Cart.prototype, {
      init: function() {
        this._initQtyLinks();

        if (!this._cookiesEnabled()) {
          this.container.classList.add(selectors.cartNoCookiesClass);
        }
      },

      _initQtyLinks: function() {
        var self = this;
        this.container.querySelectorAll(selectors.qtyLink).forEach(function(link) {
          link.addEventListener('click', self._onQtyLinkClick.bind(self));
        });
      },

      _onQtyLinkClick: function(evt) {
        var link = evt.currentTarget;
        var url;
        try {
          url = new URL(link.href);
        } catch (err) {
          return;
        }
        var line = url.searchParams.get('line');
        var quantity = url.searchParams.get('quantity');
        if (!line || quantity === null) {
          return;
        }

        evt.preventDefault();
        this._changeLineQuantity(line, quantity);
      },

      _changeLineQuantity: function(line, quantity) {
        var self = this;
        spinner();

        // Looked up from the pre-change cart -- the variant occupying a
        // given line doesn't change when only its quantity does.
        var preChangeItem = theme.cartObject && theme.cartObject.items[line - 1];
        var variantId = preChangeItem ? preChangeItem.variant_id : null;
        var requestedQuantity = parseInt(quantity, 10);

        fetch(theme.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        })
          .then(function() {
            // Ignore this response's status: a capped quantity can return non-OK yet still
            // update the cart, so /cart.js decides.
            return fetch(theme.routes.cart + '.js').then(function(res) {
              if (!res.ok) throw new Error('Cart refresh failed with status ' + res.status);
              return res.json();
            });
          })
          .then(function(cart) {
            self._updateCart(cart, requestedQuantity === 0 ? Number(line) : null);
            if (variantId !== null) checkQuantityLimit(cart, line, variantId, requestedQuantity);
          })
          .catch(function() {
            // Fall back to a full reload if the AJAX update fails, so the
            // cart is never left showing stale quantities/totals.
            location.reload();
          });
      },

      _updateCart: function(cart, removedLine) {
        if (cart.item_count === 0) {
          location.reload();
          return;
        }

        theme.cartObject = cart;

        theme.updateCartLineItems(cart, removedLine);
        theme.updateCartTotals(cart);
        theme.updateCartConditionalCheckboxes(cart);
        theme.updateCartFinancing(cart);

        spinner(false);
      },

      _cookiesEnabled: function() {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
          document.cookie = 'testcookie';
          cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
        }
        return cookieEnabled;
      }
    });

    return Cart;
  })();
})();
